import { IMargins } from './IMargins';

export class Margins implements IMargins {
    marginLeft: number;
    marginRight: number;
    marginTop: number;
    marginBottom: number;

    constructor(marginLeft: number,
        marginTop: number,
        marginRight: number,
        marginBottom: number) {
        this.marginLeft = marginLeft;
        this.marginRight = marginRight;
        this.marginTop = marginTop;
        this.marginBottom = marginBottom;
    }
}